module.exports = __webpack_public_path__ + "static/media/package.c10fca24.wav";